import { render, staticRenderFns } from "./SkeletonCardHorizontal.vue?vue&type=template&id=1845072d&scoped=true"
import script from "./SkeletonCardHorizontal.vue?vue&type=script&lang=js"
export * from "./SkeletonCardHorizontal.vue?vue&type=script&lang=js"
import style0 from "./SkeletonCardHorizontal.vue?vue&type=style&index=0&id=1845072d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1845072d",
  null
  
)

export default component.exports